import { Component, OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute } from "@angular/router";
//import { TranslateService } from "@ngx-translate/core";
import { IAgendaEvents, ReservationService } from "../shared/services/reservation.service";
import { SettingService } from "../shared/services/setting.service";


@Component({
    selector: 'reservation-confirmation-page',
    templateUrl: './reservation-confirmation-page.component.html',
    styleUrls: ['./reservation-confirmation-page.component.scss'],
    standalone: false
})

  export class ReservationConfirmationComponent implements OnInit{
    title: string = 'Nav.Reservation';
    reservationID:string;
    reservationConfirmed : boolean = false;
    reservationNotAvailable : boolean = false;
    cancelReservationFeild : boolean = false;
    modifyReservationFeild : boolean = false;
    reservationCancelled : boolean = false;
    currentAgenda : IAgendaEvents = undefined;
    guestName : string = "";
    guestPhone : string = "";
    reservationGuests : number = 1;
    reservationUpdateSuccessfull : boolean = false;
    countChildren : number = 0;
    countHighChair : number = 0;
    countBooster : number = 0;
    specialRequests : string = "";
    reservationTime : Date;

    reservationGuestName : string = "";
    reservationGuestPhone : string = "";
    reservationGuestsCount : number = 1;
    reservationDateTime : Date;
    reservationGuestEmail : string = "";
    reservationCountChildren : number = 0;
    reservationCountHighChair : number = 0;
    reservationCountBooster : number = 0;
    reservationSpecialRequests : string = "";

  

    constructor(
        public route: ActivatedRoute,
        //public translateService: TranslateService,
        public settingService: SettingService,
        private snackBar: MatSnackBar,
        private reservationService: ReservationService,
        ) {
      }
    
    ngOnInit(): void {
        //this.reservationID = this.route.snapshot.paramMap.get['reservationId'];
        this.reservationID = this.route.snapshot.params['reservationId'];
        console.log(this.reservationID);
        this.reservationService.confirmReservation(this.reservationID).subscribe(data =>{
          if(data == "N/A"){
            this.reservationNotAvailable = true;
          }
          else{
            this.reservationService.getAgendaInfo(this.reservationID).subscribe(data =>{
              if(data != undefined || data != null){
                //console.log(data);
                //this.currentAgenda = data;
                this.reservationDateTime = new Date(data.Start);
                this.reservationGuestName = data.Title;
                this.reservationGuestPhone = data.Phone;
                this.reservationGuestsCount = data.Count;
                this.reservationGuestEmail = data.Email;
                this.reservationCountChildren = data.CountChildren;
                this.reservationCountHighChair = data.CountHighChair;
                this.reservationCountBooster = data.CountBooster;
                this.reservationSpecialRequests = data.SpecialRequest;
                this.reservationConfirmed = true;
              }
            })
          }
        });
    }

    openCancelReservationFeild(){
      this.cancelReservationFeild = true;
      this.modifyReservationFeild = false;
      this.reservationUpdateSuccessfull = false;
    }
    closeCancelReservationFeild(){
      this.cancelReservationFeild = false;
    }

    openModifiyReservationFeild(){
      this.cancelReservationFeild = false;
      this.reservationService.getAgendaInfo(this.reservationID).subscribe(data =>{
        if(data != undefined || data != null){
          //console.log(data);
          this.currentAgenda = data;
          this.reservationTime = new Date(data.Start);
          this.guestName = data.Title;
          this.guestPhone = data.Phone;
          this.reservationGuests = data.Count;
          this.countBooster = data.CountBooster;
          this.countChildren = data.CountChildren;
          this.countHighChair = data.CountHighChair;
          this.specialRequests = data.SpecialRequest;
          this.modifyReservationFeild = true;
          this.reservationUpdateSuccessfull = false;
        }
      })
    }
    closeModifyReservationFeild(){
      this.modifyReservationFeild = false;
      this.currentAgenda = undefined;
      this.reservationTime = undefined;
      this.guestName = "";
      this.guestPhone = "";
      this.reservationGuests = 1;
      this.countBooster = 0;
      this.countChildren = 0;
      this.countHighChair = 0;
      this.specialRequests = "";    
    }

    cancelReservation(){
      this.reservationService.cancelReservation(this.reservationID).subscribe(data =>{
        if(data == true){
          this.reservationCancelled = true;
        }
        else{
          this.cancelReservationFeild = false;
          this.reservationConfirmed = false;
          this.reservationNotAvailable = true;
          
        }
      });
    }

    modifyReservation(){
      if(this.guestName == "" || this.guestName.length > 20){
        this.openSnackBar("Please enter valid name","close");
        return;
      }
      if(this.guestPhone.length < 10 || this.guestPhone.length > 10 || this.guestPhone == "" ){
        this.openSnackBar("Please enter a valid phone number", "close");
        return;
      }
      if(this.reservationGuests < 1){
        this.openSnackBar("Please enter valid guest Count", "close");
        return;
      }
      if(this.reservationGuests > this.currentAgenda.Count){
        this.openSnackBar("Guest Count cannot be increased", "close");
        return;
      }
      if(this.specialRequests.length > 100){
        this.openSnackBar("character limit for special request is 100","close");
        return;
      }
      if(this.countChildren < 0 || this.countChildren > this.reservationGuests || this.countChildren > this.currentAgenda.Count){
        this.openSnackBar("Please enter valid children count","close");
        return;
      }
      if(this.countBooster < 0 || this.countBooster > this.reservationGuests || this.countBooster > this.currentAgenda.Count){
        this.openSnackBar("Please enter valid booster count","close");
        return;
      }
      if(this.countHighChair < 0 || this.countHighChair > this.reservationGuests || this.countHighChair > this.currentAgenda.Count){
        this.openSnackBar("Please enter valid high chairs count","close");
        return;
      }
      this.currentAgenda.Title = this.guestName;
      this.currentAgenda.Phone = this.guestPhone;
      this.currentAgenda.Count = this.reservationGuests;
      this.currentAgenda.SpecialRequest = this.specialRequests;
      this.currentAgenda.CountChildren = this.countChildren;
      this.currentAgenda.CountBooster = this.countBooster;
      this.currentAgenda.CountHighChair = this.countHighChair;
      this.reservationService.updateReservation(this.currentAgenda).subscribe(data =>{
        if(data != "N/A"){
          this.reservationUpdateSuccessfull = true;
        }else{
          this.modifyReservationFeild = false;
          this.reservationConfirmed = false;
          this.reservationNotAvailable = true;
        }
      })
    }

    openSnackBar(message: string, action: string) {
      this.snackBar.open(message, action,{duration : 3000});
    }

  }

  